import { Link } from 'react-router-dom';

const PricingSection = () => {
  const pricingPlans = [
    {
      id: 1,
      name: "Active Trader Plan",
      price: "₹20",
      sells: "for accounts more than 50 Lakh",
      description: "Per-Order Brokerage Model",
      subtext: "Ideal For: Manual and semi-automated traders exploring advanced execution tools.",
      period: "Per Executed Order",
      animation: "fade-right",
    },
    {
      id: 2,
      name: "Algo Trader Plan",
      price: "₹10,000",
      sells: "per 1 cr trading capital",
      description: "Fixed Brokerage Plan for Less than 100 Trades/Day",
      subtext: "Ideal For: Professional and algorithmic traders running automated strategies.",
      period: "Per Month (Flat)",
      animation: "fade-up",
    },
    {
      id: 3,
      name: "Elite Trader Plan",
      price: "Custom Brokerage",
      description: "High-Frequency Custom Plan (for 100+ Trades/Day)",
      subtext: "Ideal For: HFT desks, proprietary traders, and institutions executing large volumes.",
      animation: "fade-left",
    },
  ];

  return (
    <section
      className="pricing padding-top padding-bottom py-5"
      style={{ background: "url('assets/images/new/stock-market.png')" }}
    >
      <div className="container">
        <div className="section-header section-header--max50 m-auto text-center mb-5">
          <h2 className="text-uppercase">
            <span className="style2">Custom Brokerage</span> Plans as per Deposit
          </h2>
        </div>

        <div className="pricing__wrapper">
          <div className="row g-4 align-items-stretch justify-content-center">
            {pricingPlans.map((plan) => (
              <div className="col-md-6 col-lg-4" key={plan.id}>
                <div
                  className="pricing__item text-center h-100"
                  data-aos={plan.animation}
                  data-aos-duration="1000"
                >
                  <div className="pricing__item-inner active h-100">
                    <div className="pricing__item-content d-flex flex-column justify-content-between h-100">
                      {/* Header */}
                      <div className="">
                        <h5 className="mb-2">{plan.name}</h5>
                        <h3 className="mb-1 text-primary">
                          {plan.price}{" "}
                          {plan.price !== "Custom Brokerage" && (
                            <span className="text-muted fs-6"> {plan.period}</span>
                          )}
                        </h3>
                        <div className="text-muted fw-semibold fs-6"> {plan.sells}</div>
                        <p className="fw-semibold mb-1">{plan.description}</p>
                        <p className="text-muted small">{plan.subtext}</p>
                      </div>

                    </div>
                    
                  </div>
                  
                </div>
              </div>
            ))}
            {/* Button */}
            <div className="pricing__item-bottom text-center mt-3">
              <Link
                to="#"
                className="trk-btn w-auto trk-btn--outline active"
              >
                Speak to an Advisor
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
